export default __webpack_public_path__ + "static/media/Vorschau-wird-vorbereitet.5ec9110c.webm";